var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import '../../styles/returns.scss';
import BuyItAgainErrorAlert from './BuyItAgainErrorAlert';
export default function BuyItAgainButton(_a) {
    var fulfillmentLocation = _a.fulfillmentLocation, fulfillmentType = _a.fulfillmentType, itemId = _a.itemId, quantity = _a.quantity, _b = _a.applianceStoreId, applianceStoreId = _b === void 0 ? undefined : _b, // not currently used since we dont support appliance delivery
    subscriptionDefaultFrequency = _a.subscriptionDefaultFrequency;
    var _c = useState(false), addToCartError = _c[0], setAddToCartError = _c[1];
    var _d = useState(false), subscriptionChecked = _d[0], setSubscriptionChecked = _d[1];
    var handleSubscriptionChange = function () {
        return setSubscriptionChecked(!subscriptionChecked);
    };
    var formattedItemId = itemId && typeof itemId === 'string' ? itemId : itemId === null || itemId === void 0 ? void 0 : itemId.toString();
    var addToCartReqs = __assign({ itemId: formattedItemId, quantity: "".concat(quantity), fulfillmentLocation: fulfillmentLocation, fulfillmentMethod: fulfillmentType, applianceDeliveryStore: applianceStoreId }, (subscriptionChecked && {
        subscriptions: { frequency: subscriptionDefaultFrequency },
    }));
    var getCartHost = function () {
        if (typeof window !== 'undefined') {
            var origin_1 = window.location.origin;
            return origin_1.includes('local') ? 'https://www.homedepot.com' : origin_1;
        }
        return 'https://www.homedepot.com';
    };
    var cartOptions = {
        host: getCartHost(),
        channel: isMobile ? 'mobile' : 'desktop',
        paypal: false,
        misship: false,
    };
    var handleCartFail = function () {
        setAddToCartError(true);
    };
    return (React.createElement(React.Fragment, null,
        addToCartError && React.createElement(BuyItAgainErrorAlert, null),
        React.createElement("div", { className: "card-fix" },
            React.createElement(AddToCart, { className: "card-fix", cartReqParams: addToCartReqs, cartOptions: cartOptions, onFail: handleCartFail, variant: "secondary", outline: true, fullWidth: true }, subscriptionChecked ? 'Subscribe' : 'Buy Again'))));
}
